module.exports = __webpack_public_path__ + "static/media/keyboard-backspace-24-px-2.05673de4.svg";